export { default } from './TriggerCell.jsx';
